<template>
    <b-modal id="importar-classificados-modal" size="md" centered header-bg-variant="secondary"
        header-text-variant="light" title="Importar classificados" @hidden="$emit('fecharModal')">
        <b-row>
            <b-col cols="12">
                <default-form-validation-provider label="Cargo" v-slot="defaultState">
                    <b-form-select v-model="idEditalCargo" :state="defaultState.state" :options="cargosEditais" />
                </default-form-validation-provider>
            </b-col>
            <b-col cols="12">
                <default-form-validation-provider label="Tipo de classificado" v-slot="defaultState">
                    <b-form-select v-model="idTipoClassificado" :state="defaultState.state"
                        :options="tiposClassificados" />
                </default-form-validation-provider>
            </b-col>
            <b-col cols="12" class="mt-4">
                <b-form-group id="arquivo-input-group" label="" label-for="input-arquivo" label-cols="auto">
                    <b-form-file v-model="arquivo" placeholder="Escolha o arquivo"
                        drop-placeholder="Solte o arquivo aqui" class="" browse-text="Escolher" accept=".xlsx"
                        :disabled="showLoading" />
                </b-form-group>
            </b-col>
        </b-row>
        <template v-slot:modal-footer="">
            <b-spinner v-if="showLoading" />
            <btn-download botao :fazerDownload="downloadModelo" :texto="'Baixar o modelo'" :disabled="showLoading" />
            <b-button size="sm" variant="success" @click="enviarArquivo"
                :disabled="showLoading || idTipoClassificado === '' || idEditalCargo === '' || arquivo === null">
                <font-awesome-icon icon="cloud-upload" />
                Confirmar
            </b-button>
        </template>
    </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'
import BtnDownload from '@/components/shared/btn-download.vue'
import concursoService from '@/services/atos-pessoal/concursoService'
import { SelectValue } from '@/types/select-value'
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'

const CompProps = Vue.extend({
    name: 'ModalImportarClassificados',
    components: {
        BtnDownload,
        DefaultFormValidationProvider,
    },
    props: {
        idEdital: {
            type: Number,
            required: true
        },
        cargosEditais: {
            type: Array as () => SelectValue[],
            required: true
        },
        tiposClassificados: {
            type: Array as () => SelectValue[],
            required: true
        }
    }
})

@Component
export default class ModalImportarClassificados extends mixins(UtilsTS, CompProps) {
    idEditalCargo = ''
    idTipoClassificado = ''
    arquivo: File | null = null
    showLoading = false

    async mounted() {
        this.$bvModal.show("importar-classificados-modal");
    }

    async downloadModelo() {
        const responseBlob = await concursoService.baixarModeloClassificados()
        this.download('modelo-importacao-classificados-.xlsx', responseBlob)
    }

    async enviarArquivo() {
        this.showLoading = true
        try {
            if (this.arquivo === null) {
                this.$toast.error("O arquivo deve ser informado.")
                return;
            }
            const fd = new FormData()
            fd.append('idEditalCargo', this.idEditalCargo ? String(this.idEditalCargo) : '')
            fd.append('idTipoClassificado', this.idTipoClassificado ? String(this.idTipoClassificado) : '')
            fd.append('arquivoClassificados', this.arquivo ? this.arquivo : '')
            const response = await concursoService.importarClassificadosPlanilha(fd)
            response
                ? this.$toast.success('Importação realizada com sucesso!')
                : this.$toast.error('Falha ao importar classificados.')
            this.$emit('fecharModal', true)
            this.arquivo = null
            this.idEditalCargo = ''
            this.idTipoClassificado = ''
        } catch (e: any) {
            console.error('Falha ao importar itens de licitação', e.response, e)
            this.tratarError(e)
        } finally {
            this.showLoading = false
        }
    }
}
</script>

<style scoped></style>